import type { AxiosRequestConfig } from 'axios';
import { srmInstance } from '@/shared/api/api-instances/srm/api-instance';
import type {
  CreateTQLQueryGraphView,
  TQLQueryGraphView,
  TQLQueryGraphViewBrief,
  UpdateTQLQueryGraphView,
} from '@/entities/srm/tql-query';

const defaultOptions = {
  baseURL: '/api/srm/v3',
};
export class TQLQueryGraphViewsAPI {
  static getTQLQueryGraphViewsById(id, options?: AxiosRequestConfig) {
    return srmInstance.get<TQLQueryGraphViewBrief[]>(`/query_id/${id}/view`, {
      ...defaultOptions,
      ...options,
    });
  }

  static getTQLQueryGraphViews(name, options?: AxiosRequestConfig) {
    return srmInstance.get<TQLQueryGraphViewBrief[]>(
      `/query_name/${name}/view`,
      {
        ...defaultOptions,
        ...options,
      },
    );
  }

  static getTQLQueryGraphViewsByViewName(
    queryName: string,
    viewName: string,
    options?: AxiosRequestConfig,
  ) {
    return srmInstance.get<TQLQueryGraphView>(
      `/query/${queryName}/view/${viewName}`,
      {
        ...defaultOptions,
        ...options,
      },
    );
  }

  static getTQLQueryGraphView(viewId: string, options?: AxiosRequestConfig) {
    return srmInstance.get<TQLQueryGraphView>(`/query_view/${viewId}`, {
      ...defaultOptions,
      ...options,
    });
  }
  static deleteTQLQueryGraphView(viewId: string, options?: AxiosRequestConfig) {
    return srmInstance.delete(`/query_view/${viewId}`, {
      ...defaultOptions,
      ...options,
    });
  }

  static createTQLQueryGraphView(
    payload: CreateTQLQueryGraphView,
    options?: AxiosRequestConfig,
  ) {
    return srmInstance.post<TQLQueryGraphView>(`/query_view`, payload, {
      ...options,
    });
  }

  static updateTQLQueryGraphView(
    id: string,
    payload: UpdateTQLQueryGraphView,
    options?: AxiosRequestConfig,
  ) {
    return srmInstance.put<TQLQueryGraphView>(`/query_view/${id}`, payload, {
      ...defaultOptions,
      ...options,
    });
  }
}